import SectionDescription from './sectionDescription'

export default SectionDescription
